import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";

type ILabelValue = {
  name: string,
  type: string,
  label: string,
  value: string | boolean | number,
}

export type IIndexMeta = {
  //
  oneDate: ILabelValue,
  authorizationNumber: ILabelValue,
  PAN: ILabelValue,
  dateExp: ILabelValue,
  amount: ILabelValue,
  mon: ILabelValue,
  repo: ILabelValue,
  status: ILabelValue,
  statA: ILabelValue,
  // Merchant Infos
  merchantInfo1:ILabelValue,
  merchantInfo2:ILabelValue,
  merchantInfo3:ILabelValue,
  merchantInfo4:ILabelValue,
}

const IndexMeta = {} as IIndexMeta;

IndexMeta.oneDate = {
  name: "oneDate",
  type: "date",
  label: "Date",
  value:''
};

IndexMeta.authorizationNumber = {
  name: "authorizationNumber",
  type: "text",
  label: "Numero autorisation",
  value:''
};

IndexMeta.PAN = {
  name: "PAN",
  type: "text",
  label: "PAN",
  value:''
};

IndexMeta.dateExp = {
  name: "dateExp",
  type: "date",
  label: "Date Exp.",
  value:''
};

IndexMeta.amount = {
  name: "amount",
  type: "text",
  label: "Montant",
  value:''
};

IndexMeta.mon = {
  name: "mon",
  type: "text",
  label: "Mon.",
  value:''
};

IndexMeta.repo = {
  name: "repo",
  type: "text",
  label: "Répo.",
  value:''
};

IndexMeta.status = {
  name: "status",
  type: "text",
  label: "Statut",
  value:''
};

IndexMeta.statA = {
  name: "statA",
  type: "text",
  label: "Stat. A.",
  value:''
};

// Merchant Infos
IndexMeta.merchantInfo1 = {
  name: "merchantInfo1",
  type: "text",
  label: "",
  value:''
};
IndexMeta.merchantInfo2 = {
  name: "merchantInfo2",
  type: "text",
  label: "Commerçant",
  value:''
};
IndexMeta.merchantInfo3 = {
  name: "merchantInfo3",
  type: "text",
  label: "",
  value:''
};
IndexMeta.merchantInfo4 = {
  name: "merchantInfo4",
  type: "text",
  label: "",
  value:''
};


export default IndexMeta;